import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@app/ErrorBoundary';
import CrashedComponent from '@app/components/errors/CrashedComponent';
import PostModal from '@app/components/common/modals/PostModal';
import CollectionsModal from './CollectionsModal';
import DownloadModal from './DownloadModal';
import CsvConfirmationModal from './CsvConfirmationModal';

import { useSmpContext } from './SmpContext';

const SocialMediaPostModals = () => {
    const { t } = useTranslation('measurement');
    const {
        displayPostDetailsModal,
        posts,
        activePostId,
        currency,
        closeDisplayDetails,
        closeModalWithButton,
        refetchPosts,
        isPremiumCollections,
        clientId,
        collections,
        isCollectionsModalOpen,
        closeCollectionsModal,
        onSubmitCollections,
        onErrorCollections,
        selectedArr,
        isDownloadModalOpen,
        closeDownloadModal,
        onFinishDownload,
        postsSelected,
        primaryColor,
        secondaryColor,
        isCsvDownloadModalOpen,
        closeCSVDownloadModal,
    } = useSmpContext();

    const handleCollectionRemoved = () => {
        closeModalWithButton();
        void refetchPosts();
    };

    return (
        <>
            <ErrorBoundary FallbackComponent={CrashedComponent}>
                <PostModal
                    shown={displayPostDetailsModal}
                    posts={posts}
                    postId={activePostId}
                    currency={currency}
                    onClose={closeDisplayDetails}
                    onCloseButton={closeModalWithButton}
                    onCollectionRemoved={handleCollectionRemoved}
                    canViewCollections={isPremiumCollections}
                    clientId={clientId}
                    collections={collections.list.items}
                />
            </ErrorBoundary>
            {isCollectionsModalOpen && (
                <ErrorBoundary FallbackComponent={CrashedComponent}>
                    <CollectionsModal
                        visible={isCollectionsModalOpen}
                        onClose={closeCollectionsModal}
                        onSubmit={onSubmitCollections}
                        onError={onErrorCollections}
                        collections={collections.list.items}
                        clientId={clientId}
                        postIds={selectedArr}
                        title={t(
                            'socialMediaExposure.modals.assignPostToCollections',
                        )}
                        isLoadingCollections={collections.list.isLoading}
                    />
                </ErrorBoundary>
            )}
            {isDownloadModalOpen && (
                <ErrorBoundary FallbackComponent={CrashedComponent}>
                    <DownloadModal
                        visible={isDownloadModalOpen}
                        onClose={closeDownloadModal}
                        onFinishDownload={onFinishDownload}
                        posts={postsSelected}
                        title={t('socialMediaExposure.actions.downloadPdfs')}
                        primaryColor={primaryColor}
                        secondaryColor={secondaryColor}
                    />
                </ErrorBoundary>
            )}
            {isCsvDownloadModalOpen && (
                <CsvConfirmationModal
                    title={t('socialMediaExposure.modals.downloadingCsv')}
                    onClose={closeCSVDownloadModal}
                    content={
                        <p>
                            {t('socialMediaExposure.modals.csvExportMessage')}
                        </p>
                    }
                    buttonContent={t('socialMediaExposure.modals.close')}
                    isVisible={isCsvDownloadModalOpen}
                />
            )}
        </>
    );
};

export default SocialMediaPostModals;
